import type { UserAssetRecord } from "@apis/http/api";
import type { PostVideoLibrarySubTab } from "./constants";

export const getPostVideoAssetContext = (record: UserAssetRecord): Record<string, unknown> => {
  const context = record.jobItem?.context;
  return context && typeof context === "object" ? (context as Record<string, unknown>) : {};
};

const readString = (source: Record<string, unknown>, key: string): string | undefined => {
  const value = source[key];
  return typeof value === "string" && value.length > 0 ? value : undefined;
};

export const getPostVideoAssetListKey = (record: UserAssetRecord): string => {
  if (record.id != null) {
    return String(record.id);
  }
  return String(record.jobItem?.jobId ?? record.url ?? record.fileName ?? "unknown");
};

export const getPostVideoVideoUrl = (record: UserAssetRecord): string | undefined => {
  const context = getPostVideoAssetContext(record);
  return readString(context, "videoUrl") ?? record.url;
};

export const getPostVideoCoverUrl = (record: UserAssetRecord, subTab: PostVideoLibrarySubTab): string | undefined => {
  const context = getPostVideoAssetContext(record);
  const coverFromContext = readString(context, "coverImageUrl");
  if (coverFromContext) {
    return coverFromContext;
  }
  return subTab === "generated" ? record.url : undefined;
};

export const getPostVideoProductImage = (record: UserAssetRecord): string | undefined => {
  const context = getPostVideoAssetContext(record);
  return (
    readString(context, "productImageUrl") ??
    readString(context, "productCoverImageUrl") ??
    readString(context, "coverImageUrl")
  );
};

export const getPostVideoProductTitle = (record: UserAssetRecord): string | undefined => {
  const context = getPostVideoAssetContext(record);
  return readString(context, "productTitle") ?? record.assetDescription ?? record.fileName;
};
